module.exports = __webpack_public_path__ + "static/media/mail.c82a2a75.svg";